import { ShowOnLargeScreen } from 'components/Layout';
import { Flex, Text } from '@qga/roo-ui/components';
import { SelfServiceAPI } from 'types';

interface StayInfoProps {
  booking: SelfServiceAPI.UpcomingBooking | SelfServiceAPI.PastBooking | SelfServiceAPI.CancelledBooking;
}

export const StayInfo = ({ booking }: StayInfoProps) => {
  const { totalGuests, formattedCheckIn, formattedCheckOut } = booking.reservation;

  return (
    <Flex flexDirection={['column', 'row']} mt={4}>
      <Text color="greys.steel" fontSize={16}>
        {formattedCheckIn} - {formattedCheckOut}
      </Text>
      <ShowOnLargeScreen>
        <Text px={1}> • </Text>
      </ShowOnLargeScreen>
      <Text color="greys.steel" fontSize={16}>
        {totalGuests} guests
      </Text>
    </Flex>
  );
};
